import { useIntl } from 'react-intl';

export const NoData = () => {
    const intl = useIntl();
    return <span className='text-color-light'>{intl.formatMessage({ id: 'intl-msg:livemonitor.label.noData' })}</span>;
};
